import { FormControl, FormField, FormItem, FormLabel } from "@/src/components/ui/form";
import { YachtsFiltersFormT } from "./yachts-filters.schema";
import { Checkbox } from "@/src/components/ui/checkbox";

const mainsailType = [
  {
    id: "furling",
    label: "Furling",
  },
  {
    id: "classic",
    label: "Classic",
  },
] as const;

export const MainsailType = () => {
  return (
    <div>
      <h3 className="text-lg font-semibold col-span-full  mb-4">Mainsail</h3>
      <FormField<YachtsFiltersFormT, "mainsail">
        name="mainsail"
        render={() => (
          <FormItem>
            {mainsailType.map((item) => (
              <FormField
                key={item.id}
                name="mainsail"
                render={({ field }) => {
                  return (
                    <FormItem key={item.id} className="flex flex-row items-start space-x-3 space-y-0">
                      <FormControl>
                        <Checkbox
                          className="w-6 h-6 text-base leading-6"
                          checked={field.value?.includes(item.id)}
                          onCheckedChange={(checked) => {
                            return checked
                              ? field.onChange([...field.value, item.id])
                              : field.onChange(field.value?.filter((value: string) => value !== item.id));
                          }}
                        />
                      </FormControl>
                      <FormLabel className="font-normal text-base leading-6">{item.label}</FormLabel>
                    </FormItem>
                  );
                }}
              />
            ))}
          </FormItem>
        )}
      />
    </div>
  );
};
